import React, { useContext } from "react";
import { Stack, Heading, Text } from "@chakra-ui/layout";
import {
    Button,
    Box,
    Input,
    Flex,
    Image,
    UnorderedList,
    ListItem,
    Link,
} from "@chakra-ui/react";
import { getAccount, updateUser, getAuthUrl } from "../../utils/sessionHelper";
import { useSession } from "next-auth/client";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import toast from "react-hot-toast";
import { TweetContext } from "context/tweetContext";
import { SaveIcon } from "components/icons/SaveIcon";

export function Partner({ partner, index }) {

    const [session, loading] = useSession();
    const [refresh, refresher] = React.useState({});
    const [key, setKey] = React.useState("");
    const [hasDiscount, setHasDiscount] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const isAuthenticated = useFirebaseUser();
    const tweetContext: any = useContext(TweetContext);

    React.useEffect(() => {
        // console.log("key: " + getAccount(session)?.apiKey);
        if (isAuthenticated && !key) {
            if (partner?.id && getAccount(session)?.[partner.id]) {
                setKey(getAccount(session)?.[partner.id]);
            }
        }
    }, [isAuthenticated, refresh]);

    return (
        <Flex key={"integrations" + index} >
            <Image w={["20px", "80px"]} h={["20px", "80px"]} src={partner.image} mt={[1.5, 0]} />
            <Flex flexDir="column" gap={2} ml={[2, 8]} pb={10} >
                <Heading fontSize="2xl"><Link isExternal href={partner.home}>{partner.name}</Link></Heading>
                <Box mt={2} textStyle="body.medium.light" >{partner.desc}</Box>
                {
                    partner?.hasInputKey && (
                        <Flex mt={2}>
                            <Input
                                value={key}
                                onChange={(e) => { setKey(e.target.value) }}
                                maxW={300}
                                placeholder="xxxx-xxxx-xxxx-xxxx"
                            />
                            <Button
                                ml={4}
                                isLoading={isLoading}
                                onClick={async () => {
                                    setIsLoading(true);
                                    let dataToSave = {};
                                    dataToSave[partner.id] = key
                                    await updateUser(session, dataToSave, false);
                                    setIsLoading(false);
                                    tweetContext.refresher({});
                                }}
                                // bg="blue.100"
                                // _hover={{ bg: "blue.200" }}
                                // color="gray.800"
                                variant="primary"
                                leftIcon={SaveIcon}
                            >
                                Save
                            </Button>
                        </Flex>
                    )
                }
                <Button mt={4} as="a" variant={"primary"} href={partner.link} target="_blank" maxW="200px">{partner.ctaLabel ?? "Get this integration"}</Button>
            </Flex>
        </Flex>
    )
}
